// extracted by mini-css-extract-plugin
export default {"fixesSection":"Fixes_fixesSection__9d2y1","titleGroup":"Fixes_titleGroup__cb5uv"};